/**
 * Continue Watching plugin — consumes Playback Session + Event Bus (Sprint 6C).
 * No provider-specific logic. Host no longer owns CW timers directly.
 */
import { createPlugin } from "../createPlugin";
import { PlayerEvent } from "../../Core/PlayerEvents";
import { PlaybackPlatformEvent } from "../../Core/PlaybackPlatformEvents";
import {
  createContinueWatchingSession,
} from "../../production/ContinueWatchingService";

/**
 * @param {object} options
 * @param {function} options.getStateService () => PlaybackStateService
 * @param {number} [options.intervalMs]
 */
export function createContinueWatchingPlugin(options) {
  options = options || {};
  var intervalMs = options.intervalMs != null ? options.intervalMs : 3000;

  return createPlugin({
    name: "continue-watching",
    version: "1.0.0",
    onRegister: function (ctx) {
      ctx._cwPlugin = { session: null, started: false };
      if (ctx.getCapabilities && ctx.eventBus) {
        /* state service optional via options */
      }
    },
    onReady: function (ctx) {
      if (typeof options.getStateService === "function") {
        var svc = options.getStateService();
        if (svc && svc.registerPluginName) {
          svc.registerPluginName("continue-watching");
        }
      }
    },
    onEvent: function (eventName, payload, ctx) {
      var isPlay =
        eventName === PlayerEvent.PLAYBACK_STARTED ||
        eventName === PlayerEvent.PLAY ||
        eventName === PlaybackPlatformEvent.PLAY;
      var isPause =
        eventName === PlayerEvent.PLAYBACK_PAUSED ||
        eventName === PlayerEvent.PAUSE ||
        eventName === PlaybackPlatformEvent.PAUSE;
      var isEnded =
        eventName === PlayerEvent.PLAYBACK_ENDED ||
        eventName === PlaybackPlatformEvent.ENDED ||
        eventName === "ended";

      var svc =
        typeof options.getStateService === "function"
          ? options.getStateService()
          : null;
      if (!svc) return;

      var intro = svc.getIntro && svc.getIntro();
      if (intro && intro.active) {
        return; // never CW during cinematic intro
      }

      var content = svc.getContent && svc.getContent();
      if (content && content.mediaKind === "trailer") {
        return;
      }

      var sessionSnap = svc.getSession ? svc.getSession().snapshot() : null;
      var viewer = (sessionSnap && sessionSnap.viewer) || {};

      if (isPlay) {
        if (!ctx._cwPlugin.session) {
          ctx._cwPlugin.session = createContinueWatchingSession(
            function () {
              return svc.getPosition() || 0;
            },
            {
              userId: viewer.userId,
              accessToken:
                typeof localStorage !== "undefined"
                  ? localStorage.getItem("accessToken")
                  : null,
              subProfileId: viewer.profileId,
              adminVideoId: content && content.contentId,
              intervalMs: intervalMs,
            }
          );
        }
        ctx._cwPlugin.session.start();
        ctx._cwPlugin.started = true;
      }

      if (isPause && ctx._cwPlugin.session) {
        if (typeof ctx._cwPlugin.session.pause === "function") {
          ctx._cwPlugin.session.pause();
        } else {
          ctx._cwPlugin.session.stop();
        }
      }

      if (isEnded && ctx._cwPlugin.session) {
        ctx._cwPlugin.session.stop();
        ctx._cwPlugin.started = false;
      }
    },
    onDestroy: function (ctx) {
      if (ctx._cwPlugin && ctx._cwPlugin.session) {
        ctx._cwPlugin.session.stop();
        ctx._cwPlugin.session = null;
      }
    },
  });
}

export default createContinueWatchingPlugin;
